import React, { Suspense, useRef, useEffect } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import HeaderAndFooter from '@src/layout/headerAndFooter';
import HeaderOnly from '@src/layout/headerOnly';
import PersonalNav from '@src/nodes/personalCenter/personalNav';
import AccountSetting from '@src/nodes/personalCenter/accountSetting';
import DeliveryRecord from '@src/nodes/personalCenter/deliveryRecord';
import ResumeDetail from '@src/nodes/personalCenter/resumeDetail';
import { useRootStore } from '@src/model';
import Auth from '@elements/Auth';
import WaitJsLoading from '@elements/WaitJsLoading';
import { addRaptorCustomError } from '@utils/owlLog';
import NotFound from '../nodes/notFound';
import config from './config';

export default function App() {
  const { loginStore, cmsData } = useRootStore();
  const timer = useRef<NodeJS.Timeout | null>(null);

  const evtListener = (e) => {
    cmsData.setCmsData(e.value?.data);
    if (e.value?.error) {
      addRaptorCustomError(
        '[自定义日志打点上报-cms接口异常]',
        'cms接口异常',
        {
          error: JSON.stringify(e.value?.error),
        },
        'error',
      );
    }
    if (timer.current) clearTimeout(timer.current);
  };

  const handleGetCmsData = () => {
    timer.current = setTimeout(() => {
      cmsData.setCmsData(null);
      addRaptorCustomError('[自定义日志打点上报-cms接口超时]', 'cms接口超时', {}, 'error');
    }, 3000);

    if (window.cmsData?.data || window.cmsData?.data === null) {
      cmsData.setCmsData(window.cmsData.data);
      if (window.cmsData.error) {
        addRaptorCustomError(
          '[自定义日志打点上报-cms接口异常]',
          'cms接口异常',
          {
            error: JSON.stringify(window.cmsData.error),
          },
          'error',
        );
      }
      if (timer.current) clearTimeout(timer.current);
    } else {
      document.addEventListener('cms', evtListener);
    }
  };

  useEffect(() => {
    loginStore.getUserInfo();
    handleGetCmsData();
    return () => document.removeEventListener('cms', evtListener);
  }, []);

  return (
    <Suspense fallback={<WaitJsLoading />}>
      <BrowserRouter basename="web">
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          {config.map((routeItem) => {
            let element = React.createElement(routeItem.component);
            if (routeItem.withHeaderAndFooter) {
              element = <HeaderAndFooter isStickyHeader={routeItem.isStickyHeader}>{element}</HeaderAndFooter>;
            }
            if (routeItem.withHeaderOnly) {
              element = <HeaderOnly isStickyHeader={routeItem.isStickyHeader}>{element}</HeaderOnly>;
            }
            if (routeItem.isAuth) {
              element = <Auth>{element}</Auth>;
            }
            return <Route key={routeItem.path} path={routeItem.path} element={element} />;
          })}
          <Route
            path="personalCenter"
            element={
              <Auth>
                <HeaderOnly isStickyHeader>
                  <PersonalNav />
                </HeaderOnly>
              </Auth>
            }
          >
            <Route path="accountSetting" element={<AccountSetting />} />
            <Route path="deliveryRecord" element={<DeliveryRecord />} />
            <Route path="resumeDetail" element={<ResumeDetail />} />
            <Route path="" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route
            path="*"
            element={
              <HeaderAndFooter isStickyHeader>
                <NotFound />
              </HeaderAndFooter>
            }
          />
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}
